export const SWITCH_LANG = 'SWITCH_LANG'; // 头部的切换语言

export const INIT_SELECT_BOX = 'INIT_SELECT_BOX'; // 初始化通用选择框
export const TOGGLE_SELECT_BOX = 'TOGGLE_SELECT_BOX'; // 开闭通用选择框

export const INIT_WORKLIST = 'INIT_WORKLIST'; // 初始化工单列表
export const INIT_WORK_DETAIL_LIST = 'INIT_WORK_DETAIL_LIST'; // 初始化工单详情
export const CLEAR_WORK_DETAIL_LIST = 'CLEAR_WORK_DETAIL_LIST'; // 清除工单详情，为再次初始化做准备

export const TOGGLE_MASK = 'TOGGLE_MASK'; // 开闭通用遮罩层

export const TOAST = 'TOAST'; // 弹出系统提示
export const CLOSE_TOAST = 'CLOSE_TOAST'; // 关闭系统提示

export const CLOSE_IMAGE_PREVIEW = 'CLOSE_IMAGE_PREVIEW'; // 关闭图片预览
export const OPEN_IMAGE_PREVIEW = 'OPEN_IMAGE_PREVIEW'; // 预览图片

export const OPEN_PAGE_NAME = 'OPEN_PAGE_NAME'; // 用户初次打开页面
